<template>
  <div class="cbm-opportunity">
    <div class="cbm-text-icon-container">
      <mf-icon fill :size="50" color="#0063C6" icon="lightbulb_circle" />
      <div class="cbm-text-container">
        <span class="title">Está procurando por dados e ofertas exclusivas?</span>
        <span>Não perca tempo e faça parte do time de Mercamonster, obtenha o CBM e amplie as ofertas do seu comércio. </span>
      </div>
    </div>
    <get-cbm-form-modal id="get-cbm-form" ref="getCbm"></get-cbm-form-modal>
  </div>
</template>

<script>
import GetCbmFormModal from './GetCbmFormModal.vue'

export default {
  name: 'CbmOpportunityCard',
  components: {
    GetCbmFormModal,
  },
}
</script>

<style scoped lang="scss">
.cbm-opportunity {
  padding: 22px 40px;
  background-color: #d2e9ff;
  border: 1px solid $cinza-l80;
  border-radius: 3px;
  min-height: 86px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .cbm-text-icon-container {
    display: flex;
    align-items: center;
    gap: 30px;
    .cbm-text-container {
      display: flex;
      flex-direction: column;
      color: $marca-0;

      .title {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }
}
</style>
